export default "__VITE_ASSET__3cbbQpDn__"